<template>
  <transition name="modal-fade">
    <div v-if="visible && message" class="modal-mask">
      <div class="modal-panel" role="dialog" aria-modal="true">
        <div class="panel-header">
          <h2>{{ message.title || '站内私信' }}</h2>
          <button type="button" class="close-btn" aria-label="关闭" @click="handleClose">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="panel-body">
          <div class="message-time">{{ formatTime(message.createTime) }}</div>
          <div class="message-content">{{ message.content }}</div>
        </div>
        <div class="panel-footer">
          <button type="button" class="btn-primary" :disabled="reading" @click="handleClose">
            {{ reading ? '处理中...' : '知道了' }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { getPopupMessage, readMessage } from '@/api/portal/message'
import { isLoggedIn } from '@/utils/auth'
import { onLoginSuccess, offLoginSuccess } from '@/utils/loginModal'
import { emitMessageUnreadChanged } from '@/utils/userMenu'

export default {
  name: 'MemberMessagePopup',
  data() {
    return {
      visible: false,
      reading: false,
      message: null
    }
  },
  mounted() {
    onLoginSuccess(this.checkPopup)
    if (isLoggedIn()) {
      this.checkPopup()
    }
  },
  beforeDestroy() {
    offLoginSuccess(this.checkPopup)
  },
  methods: {
    checkPopup() {
      if (!isLoggedIn()) {
        return
      }
      getPopupMessage()
        .then(res => {
          const data = res.data
          if (data && data.messageId) {
            this.message = data
            this.visible = true
          }
        })
        .catch(() => {})
    },
    handleClose() {
      if (!this.message || this.reading) {
        return
      }
      this.reading = true
      readMessage(this.message.messageId)
        .finally(() => {
          this.reading = false
          this.visible = false
          this.message = null
          emitMessageUnreadChanged()
          this.$nextTick(() => this.checkPopup())
        })
    },
    formatTime(val) {
      if (!val) {
        return ''
      }
      return String(val).replace('T', ' ').slice(0, 16)
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  inset: 0;
  z-index: 2350;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(4px);
}

.modal-panel {
  width: min(520px, 100%);
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 24px 48px rgba(79, 70, 229, 0.18);
  overflow: hidden;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px 12px;
  border-bottom: 1px solid #eef0f8;
}

.panel-header h2 {
  margin: 0;
  font-size: 18px;
  color: #1f2937;
}

.close-btn {
  border: none;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  font-size: 18px;
}

.panel-body {
  padding: 16px 20px 8px;
}

.message-time {
  margin-bottom: 12px;
  font-size: 12px;
  color: #94a3b8;
}

.message-content {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.7;
  color: #334155;
  font-size: 14px;
  max-height: 360px;
  overflow-y: auto;
}

.panel-footer {
  padding: 16px 20px 20px;
  display: flex;
  justify-content: flex-end;
}

.btn-primary {
  min-width: 96px;
  padding: 10px 18px;
  border: none;
  border-radius: 10px;
  background: #1976d2;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
